import { render, staticRenderFns } from "./DeliveryPointDescriptionCard.vue?vue&type=template&id=5ac01a76&scoped=true"
import script from "./DeliveryPointDescriptionCard.vue?vue&type=script&lang=js"
export * from "./DeliveryPointDescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointDescriptionCard.vue?vue&type=style&index=0&id=5ac01a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac01a76",
  null
  
)

export default component.exports